import { defineNuxtPlugin, useHead, useRoute, useRuntimeConfig } from "#imports";


export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		const route = useRoute();
		const runtimeConfig = useRuntimeConfig();
		// if (validRoutes.includes(route.path) && ['local', 'dev'].includes(runtimeConfig.public.appEnv)) {
		// }
		// useHead(
		// 	{
		// 		script: [
		// 			{
		// 				hid: 'jivochat',
		// 				children: `
		// 					const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJob3N0IjoiaHR0cHM6Ly92YWlkZWJvbHNhLmNvbS5iciIsImlkIjoiNjQ3NTE2YmU5ZDNiZjNiMjhmNDBlYmQzIiwiYWNjSWQiOiI2NDZmYzA5ZjdiMTI1OGYzNjgzNjhkMmYiLCJpYXQiOjE2ODUzOTUxMzR9.4RlEWCJtvLhkGVqet7Tl-s6FtHukxRM_SSkRjVLqWjc";
		// 					(function(w, d, s, u, t) {
		// 					w.Chatty = function(c) { w.Chatty._.push(c) };
		// 					w.Chatty._ = [];
		// 					w.Chatty.url = u;
		// 					w.Chatty.hash = t;
		// 					var h = d.getElementsByTagName(s)[0],
		// 						j = d.createElement(s);
		// 					j.async = true;
		// 					j.src = 'https://widget.gallabox.com/chatty-widget.min.js?_=' + Math.random();
		// 					h.parentNode.insertBefore(j, h);
		// 					})(window, document, 'script', 'https://widget.gallabox.com', token);
		// 				`,
		// 				async: true
		// 			}
		// 		]
		// 	}
		// );
	}
});
